"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var ordered_1 = require("../../utils/selectors/ordered");
var BenchmarksAccordion_1 = __importDefault(require("./BenchmarksAccordion"));
var Wrapper_1 = __importDefault(require("./styles/Wrapper"));
var BenchmarksTable = function () {
    var allServices = (0, react_redux_1.useSelector)(ordered_1.selectServices);
    if (!(0, react_redux_firebase_1.isLoaded)(allServices))
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    var sStats = __spreadArray([allServices.find(function (s) { return s.name === 'HubSpot'; })], __read(allServices.slice(0, 20)), false).filter(end2end_1.notFalsy).map(function (service) { return ({ service: service }); });
    return ((0, jsx_runtime_1.jsx)(Wrapper_1.default, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ maxWidth: 900, pt: 1, pl: 1 }, { children: sStats === null || sStats === void 0 ? void 0 : sStats.map(function (sStat) { return ((0, jsx_runtime_1.jsx)(BenchmarksAccordion_1.default, { serviceStat: sStat }, sStat.service.id)); }) })) }));
};
exports.default = BenchmarksTable;
